const deserializeSearchParams = (query: string) => {
    const searchParams = new URLSearchParams(query);

    return Object.fromEntries<string>(searchParams.entries());
};

export default deserializeSearchParams;
